import ButtonVariant from "app/components/Button/ButtonVariant";
import Modal from "../Modal";
import styles from "./style.module.scss";
import React from "react";

const TextAreaModal = ({
  title,
  subTitle,
  width,
  textAreaStyle = "",
  placeholder,
  subTitle2 = null,
  value = null,
  setValue = (_param) => null,
  confirmText,
  cancelText,
  setShowModal,
  handleAction,
  showCloseIcon = false,
  topImage,
  stackedButtons = false,
  confirmFirst = false,
  customConfirmStyle = "",
  customCancelStyle = "",
  hideTextArea = false,
  confirmDisabled = false,
  additionalContent = null,
}) => {
  const confirmButton = (
    <ButtonVariant
      title={confirmText}
      buttonType='primary'
      onClickFunc={handleAction}
      buttonStyles={customConfirmStyle}
      disabled={confirmDisabled}
    />
  );

  const cancelButton = (
    <ButtonVariant
      title={cancelText}
      buttonType='secondary-outline'
      onClickFunc={() => setShowModal(false)}
      buttonStyles={customCancelStyle}
    />
  );
  return (
    <Modal
      topImage={topImage}
      showModal={setShowModal}
      title={title}
      showCloseIcon={showCloseIcon}
      width={width}
      cancelButtonProp={cancelButton}
      confirmButton={confirmButton}
      stackedButtons={stackedButtons}
      confirmFirst={confirmFirst}
    >
      {hideTextArea ? (
        <div className={styles.white_container} />
      ) : (
        <div className={styles.white_container}>
          {subTitle2 && (
            <p className={styles.first_subtitle}>{subTitle2}</p>
          )}
          <p>{subTitle}</p>
          <div>
            <textarea
              placeholder={placeholder}
              data-testid="long-description"
              value={value}
              onChange={(event) => setValue(event.target.value)}
              className={`${styles.textarea} ${textAreaStyle}`}
            />
          </div>
          {additionalContent}
        </div>
      )}
    </Modal>
  );
};

export default TextAreaModal;
